import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import useMobileDetect from 'helpers/mobile-detect'
import { smoothScrollTo } from 'helpers/scrollTo'
import Image from 'next/image'

import styles from './about-banner.module.scss'

export default function AboutBanner (props) {
  const [imgWidth, setImgWidth] = useState(1440)
  const [imgHeight, setImgHeight] = useState(652)
  const [imageUrl, setImageUrl] = useState('/static/images/about/bg-banner.png')
  const currentDevice = useMobileDetect()

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/about/bg-m-banner.png')
      setImgWidth(375)
      setImgHeight(462)
    } else {
      setImageUrl('/static/images/about/bg-banner.png')
      setImgWidth(1440)
      setImgHeight(652)
    }
  }, [currentDevice.width])

  const moveToProgram = () => {
    const element = document.getElementById('choose-program')
    if (element) {
      smoothScrollTo('#choose-program')
    }
  }

  return (
    <section className={styles['about-banner']}>
      <div className={styles['about-banner__wrapper']}>
        <Image src={imageUrl} alt='Mike Dolce' width={imgWidth} height={imgHeight} className={'w-100 h-auto'} />
        <div className={styles['about-banner__caption']}>
          <h2 className={styles['about-banner__title']}>MIKE DOLCE</h2>
          <p className={styles['about-banner__content']}>"Mike Dolce is one of the most sought after coaches in professional sports." <span> -Sports Illustrated</span></p>
          <Button variant='danger' className={styles['about-banner__shredded'] + ' no-border bg-red'} onClick={moveToProgram}>
            Try 3 Weeks to Shredded!
          </Button>
          <a href='/contact' className={styles['about-banner__athlete'] + ' btn bg-transparent'}>
            Pro athlete? get in touch {'>'}
          </a>
        </div>
      </div>
    </section>
  )
}
